import { jotaiStorage } from '../atom';

export const deleteUser = () => {
  jotaiStorage.removeItem('user');
};
